
<template>
  <div>
    <h1>Test multi</h1>
    <p>router links naar componenten</p>
    <div style="background-color:lightgray">
      <router-view></router-view>
    </div>
  </div>
</template>


<script>
export default {
  name: 'multimain',

  components: {},

  props: {},
  data: function() {
    return {}
  },
  mounted: function() {},
  methods: {},
  computed: {}
}
</script>
